import React from "react";
import Txt from "../../../../components/typography/Txt";
import Flx from "../../../../components/layout/Flx";
import { grey } from "@mui/material/colors";
import { isArray, isNil, isObject, isString } from "lodash";

const DetailField = ({ label, value }) => (
  <Flx column sx={{ display: "flex", alignItems: "flex-start", gap: 0, py: 1 }}>
    <Txt
      sx={{
        // fontSize: "11px",
        fontSize: "10px",
        color: grey[500],
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        lineHeight: 1.2,
      }}
    >
      {label}
    </Txt>

    <Txt
      sx={{
        fontSize: "11px",
        fontWeight: 500,
        color: grey[800],
        mt: 0.25,
        wordBreak: "break-word",
      }}
    >
      {isNil(value) || isObject(value) || isArray(value) ? "—" : value}
    </Txt>
  </Flx>
);
export default DetailField;
